const to12 = (hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};
const plus = (hhmm, mins) => { const [h, m] = hhmm.split(":").map(Number); const t = h * 60 + m + mins; return `${String(Math.floor(t / 60) % 24).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`; };
const PARTS = [["Morning", 0, 12], ["Afternoon", 12, 17], ["Evening", 17, 24]];

// Clickable time blocks grouped by part of day; booked/too-soon slots are shown greyed out.
export function SlotGrid({ slots, value, onPick, duration = 30, testid = "slot" }) {
  return (
    <div className="space-y-3" data-testid={`${testid}-grid`}>
      {PARTS.map(([label, from, to]) => {
        const list = slots.filter((s) => { const h = Number(s.start.slice(0, 2)); return h >= from && h < to; });
        if (!list.length) return null;
        return (
          <div key={label}>
            <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-400 mb-1.5">{label}</div>
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
              {list.map((s) => {
                const on = value === s.start;
                const off = s.available === false;
                return (
                  <button key={s.start} type="button" disabled={off} onClick={() => onPick(s.start)} data-testid={`${testid}-${s.start}`}
                    className={`rounded-xl border px-2 py-2 text-center transition-colors ${on ? "bg-primary border-primary text-white shadow-sm" : off ? "bg-slate-50 border-slate-100 text-slate-300 line-through cursor-not-allowed" : "bg-white border-slate-200 text-slate-800 hover:border-primary hover:bg-primary/5"}`}>
                    <div className="text-sm font-semibold">{to12(s.start)}</div>
                    <div className={`text-[10px] ${on ? "text-white/80" : "text-slate-400"}`}>{off ? "Booked" : `to ${to12(plus(s.start, duration))}`}</div>
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
